import React from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import { chakraTheme } from './theme';

function ChakraThemeProvider({ children }) {
  return <ChakraProvider theme={chakraTheme}>{children}</ChakraProvider>;
}

export default ChakraThemeProvider;
